import { HabitSchedule, Timestamp } from '@griply/types';
import { isAfter, isBefore, startOfDay } from 'date-fns';

export type GroupedSchedules = {
  current: HabitSchedule[];
  upcoming: HabitSchedule[];
  history: HabitSchedule[];
};

export const groupSchedulesByTime = (
  schedules: HabitSchedule[],
  today: Timestamp,
): GroupedSchedules => {
  const todayStart = startOfDay(today);

  const sortedSchedules = schedules
    .slice()
    .sort((a, b) => b.startDate.getTime() - a.startDate.getTime());

  const current: HabitSchedule[] = [];
  const upcoming: HabitSchedule[] = [];
  const history: HabitSchedule[] = [];

  sortedSchedules.forEach((schedule) => {
    if (isAfter(startOfDay(schedule.startDate), todayStart)) {
      upcoming.push(schedule);
      return;
    }

    if (
      schedule.endDate &&
      isBefore(startOfDay(schedule.endDate), todayStart)
    ) {
      history.push(schedule);
      return;
    }

    current.push(schedule);
  });

  return { current, upcoming, history };
};
